jQuery(document).ready(function($) {
	$('.highlight-slider-container').each(function() {
		var sliderNavContainer = $(this).closest('.highlight-slider').find('.highlight-slider-nav');
		var sliderCounter = $(this).closest('.highlight-slider').find('.highlight-slider-counter span');
		var progressBar = $(this).closest('.highlight-slider').find('.highlight-slider-progress-bar');
		$(this).slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			adaptiveHeight: false,
			arrows: true,
	        draggable: false,
	        autoplay: true,
	        autoplaySpeed: 7500,
	        appendArrows: sliderNavContainer,
			prevArrow: '<button type="button" class="slick-prev button primary"><div class="dotted-border left slider-nav"></div><span class="screen-reader-only">Forrige</span></button>',
            nextArrow: '<button type="button" class="slick-next button primary"><div class="dotted-border right slider-nav"></div><span class="screen-reader-only">Neste</span></button>'
		});
		progressBar.addClass('show-progress');
		$(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
			progressBar.addClass('reset-progress');
		});
		$(this).on('afterChange', function(event, slick, currentSlide, nextSlide){
		    var i = (currentSlide ? currentSlide : 0) + 1;
		    sliderCounter.text(i);
			window.setTimeout(function(progressBar) {
				progressBar.removeClass('reset-progress').addClass('show-progress');
			}, 150, progressBar);
		});
	});
	
	var adjustSlideHeights = function() {
		var newHeight = 0;
		$('.highlight-slider-container').each(function() {
			$(this).find('.slide:not(.slick-cloned) p').each(function() {
				if ($(this).height()>newHeight) {
					newHeight = $(this).height();
				}
			});
			$(this).find('.content-wrapper').css('min-height', newHeight + 80);
		});
	}

	var hsResizeTimeout = false;
	$(window).resize(function() {
		clearTimeout(hsResizeTimeout);
		hsResizeTimeout = setTimeout(adjustSlideHeights, 250);
	});
	adjustSlideHeights();

});
